<template>
  <div class="point-balance">
    <b-table
      v-if="list.length > 0"
      class="table table-responsive table-bordered mt-5"
      hover
      :fields="pointFields"
      :items="list"
      responsive
    >
      <template #cell(pointBalance)="data">
        <div>{{ data.item.pointBalance.toLocaleString() }}</div>
      </template>
      <template #cell(redeemablePoints)="data">
        <div>{{ data.item.redeemablePoints.toLocaleString() }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      id: this.$route.query.id,
      pointFields: [
        {
          key: "brandCode",
          label: "Brand",
          thClass: "text-start",
          tdClass: "text-start",
          sortable: true,
        },
        {
          key: "year",
          label: "Year",
          thClass: "text-start",
          tdClass: "text-start",
          sortable: true,
        },
        {
          key: "pointBalance",
          label: "Point balance",
          thClass: "text-center",
          tdClass: "text-end",
          sortable: true,
        },
        {
          key: "redeemablePoints",
          label: "Redeemable points",
          thClass: "text-center",
          tdClass: "text-end",
          sortable: true,
        },
      ],
    };
  },
};
</script>
